import { useId } from 'react';

import { type RadioGroupProps, Text, View, RadioGroup as ZincRadioGroup } from '@zinc/ui';

type Props = Omit<RadioGroupProps, 'onChange'> & {
  errorText?: string;
  direction?: 'row' | 'column';
  gap?: number;
  onChange: (value: string) => void;
  name?: string;
};

export default function RadioGroup(props: Props) {
  const id = useId();
  const { errorText, children, direction = 'column', gap = 2, onChange, name = id } = props;
  return (
    <ZincRadioGroup {...{ ...props, name }} onChange={({ value }) => onChange(value)}>
      <View gap={gap} direction={direction}>
        {children}
      </View>
      {errorText && <Text color="critical">{errorText}</Text>}
    </ZincRadioGroup>
  );
}
